import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import axios from 'axios';
import locale from '../locale';
import Button from '../Button';
import createRef from '@roo/create-react-ref/createRef';
import { clone } from '@utiljs/clone';
import { isFunction } from '@utiljs/is';
import warning from 'warning';

var FileInput = /*#__PURE__*/function (_React$Component) {
  _inherits(FileInput, _React$Component);

  var _super = _createSuper(FileInput);

  function FileInput() {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _super.apply(this, arguments);
    _this.fileupload = createRef();
    _this.state = {
      maxSize: (_this.props.maxSize || 2) * 1024 * 1000,
      name: _this.props.defaultFileName || '',
      fileData: '',
      file: {},
      fileList: [],
      prevProps: {}
    };

    _this.handleChange = function (event) {
      var current = _this.fileupload.current;

      if (current && current.files && current.files[0]) {
        var files = current.files[0]; // validity params

        if (!_this.validityParams(files)) {
          _this.clearTargetVal(event);

          return false;
        } // preview


        _this.previewFile(files, function (result) {
          _this.preHandleUpload(files, result);
        });
      }

      _this.clearTargetVal(event);
    };

    _this.preHandleUpload = function (files, result) {
      _this.setState({
        fileData: result,
        file: files,
        name: files.name,
        fileList: [files]
      }, function () {
        var onChange = _this.props.onChange;
        var _this$state = _this.state,
            file = _this$state.file,
            fileData = _this$state.fileData,
            fileList = _this$state.fileList; // onChange hook

        if (onChange) {
          onChange(clone({
            name: file.name,
            size: file.size,
            type: file.type,
            data: fileData
          }), clone(fileList));
        } // beforeUpload hook


        var beforeUpload = _this.handleBeforeUpload();

        if (beforeUpload && beforeUpload.then) {
          beforeUpload.then(function () {
            _this.handleAutoUpload();
          }).catch(function (e) {
            console.log(e);
          });
        } else if (beforeUpload !== false) {
          _this.handleAutoUpload();
        }
      });
    };

    _this.clearTargetVal = function (event) {
      event.target.value = '';
    };

    _this.clearFileVal = function () {
      var current = _this.fileupload.current;

      if (current) {
        current.value = '';
      }
    };
    /**
     * 清除文件上传组件的内部状态
     * @public 公共方法
     */


    _this.clearInput = function () {
      _this.clearFileVal();

      _this.setState({
        fileData: '',
        name: ''
      });
    };

    _this.handleRemove = function () {
      var onRemove = _this.props.onRemove;
      var _this$state2 = _this.state,
          file = _this$state2.file,
          fileData = _this$state2.fileData;

      if (onRemove) {
        //@ts-ignore
        onRemove(clone({
          name: file.name,
          size: file.size,
          type: file.type,
          data: fileData
        }));
      }

      _this.clearInput();
    };

    _this.handleBeforeUpload = function () {
      var beforeUpload = _this.props.beforeUpload;
      var _this$state3 = _this.state,
          file = _this$state3.file,
          fileData = _this$state3.fileData,
          fileList = _this$state3.fileList;

      if (beforeUpload) {
        return beforeUpload(clone({
          name: file.name,
          size: file.size,
          type: file.type,
          data: fileData
        }), clone(fileList));
      }

      return undefined;
    };

    _this.handleAutoUpload = function () {
      var _this$props = _this.props,
          autoUpload = _this$props.autoUpload,
          onSucess = _this$props.onSucess,
          onSuccess = _this$props.onSuccess,
          onFail = _this$props.onFail;

      if (autoUpload) {
        _this.handleUpload().then(function (resp) {
          if (isFunction(onSucess)) {
            warning(false, 'onSucess 将被舍弃，请使用 onSuccess');
            onSucess(resp);
          }

          if (isFunction(onSuccess)) {
            onSuccess(resp);
          }
        }).catch(function (err) {
          // onFail hook
          if (onFail) {
            onFail(err);
          }
        });
      }
    };

    _this.handleUpload = function () {
      var _this$props2 = _this.props,
          action = _this$props2.action,
          uploadParams = _this$props2.uploadParams,
          name = _this$props2.name,
          withCredentials = _this$props2.withCredentials,
          dataFormat = _this$props2.dataFormat;
      var _this$state4 = _this.state,
          fileData = _this$state4.fileData,
          file = _this$state4.file;
      var data;

      if (dataFormat.toLocaleLowerCase() === 'FileData'.toLocaleLowerCase()) {
        var formData = new FormData();
        formData.append(name, file);

        if (_Object$keys(uploadParams) && _Object$keys(uploadParams).length) {
          for (var key in uploadParams) {
            if (uploadParams.hasOwnProperty(key)) {
              formData.append(key, uploadParams[key]);
            }
          }
        }

        data = formData;
      } else {
        data = _Object$assign(_defineProperty({}, name, fileData), uploadParams);
      }

      return new _Promise(function (resolve, reject) {
        axios({
          method: 'post',
          url: action,
          data: data,
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: withCredentials
        }).then(function (resp) {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(new Error('upload error'));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    };

    _this.previewFile = function (file, callback) {
      var reader = new FileReader();

      reader.onloadend = function () {
        return callback(reader.result);
      };

      reader.readAsDataURL(file);
    };

    _this.validityParams = function (files) {
      var maxSize = _this.state.maxSize;

      if (files.size <= maxSize) {
        return true;
      } // validityFailCallback hook


      var validityFailCallback = _this.props.validityFailCallback;

      if (validityFailCallback) {
        validityFailCallback(clone({
          name: files.name,
          size: files.size,
          type: files.type
        }));
      }

      return false;
    };

    return _this;
  }

  _createClass(FileInput, [{
    key: "render",
    value: function render() {
      var name = this.state.name;

      var _a = this.props,
          accept = _a.accept,
          className = _a.className,
          style = _a.style,
          disabled = _a.disabled,
          autoUpload = _a.autoUpload,
          uploadParams = _a.uploadParams,
          maxSize = _a.maxSize,
          withCredentials = _a.withCredentials,
          dataFormat = _a.dataFormat,
          defaultFileName = _a.defaultFileName,
          onRemove = _a.onRemove,
          beforeUpload = _a.beforeUpload,
          onChange = _a.onChange,
          onSucess = _a.onSucess,
          onSuccess = _a.onSuccess,
          onFail = _a.onFail,
          placeholder = _a.placeholder,
          buttonOnly = _a.buttonOnly,
          validityFailCallback = _a.validityFailCallback,
          btnText = _a.btnText,
          btnProps = _a.btnProps,
          removeBtnText = _a.removeBtnText,
          removeBtnProps = _a.removeBtnProps,
          restProps = __rest(_a, ["accept", "className", "style", "disabled", "autoUpload", "uploadParams", "maxSize", "withCredentials", "dataFormat", "defaultFileName", "onRemove", "beforeUpload", "onChange", "onSucess", "onSuccess", "onFail", "placeholder", "buttonOnly", "validityFailCallback", "btnText", "btnProps", "removeBtnText", "removeBtnProps"]);

      return /*#__PURE__*/React.createElement("div", _Object$assign({}, restProps, {
        className: classNames('roo-input-group', className || ''),
        style: style || {}
      }), buttonOnly ? null : /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "roo-input",
        placeholder: placeholder,
        value: name,
        readOnly: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group-append"
      }, name ? /*#__PURE__*/React.createElement(Button, _Object$assign({
        type: "hollow",
        onClick: this.handleRemove,
        disabled: disabled
      }, removeBtnProps), /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-trash-o"
      }), removeBtnText) : null, /*#__PURE__*/React.createElement(Button, _Object$assign({
        className: "roo-btn-upload",
        disabled: disabled
      }, btnProps), /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-file-text"
      }), btnText, /*#__PURE__*/React.createElement("input", {
        className: "file-input",
        type: "file",
        disabled: disabled,
        ref: this.fileupload,
        onChange: this.handleChange,
        accept: accept
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;

      if (nextProps.defaultFileName !== prevProps.defaultFileName) {
        return {
          prevProps: nextProps,
          name: nextProps.defaultFileName
        };
      }

      return null;
    }
  }]);

  return FileInput;
}(React.Component);

FileInput.defaultProps = {
  action: undefined,
  autoUpload: false,
  disabled: false,
  defaultFileName: undefined,
  uploadParams: {},
  name: 'file',
  maxSize: 2,
  withCredentials: false,
  accept: '',
  dataFormat: 'FileData',
  placeholder: locale.lng('FileInput.placeholder'),
  buttonOnly: false,
  validityFailCallback: function validityFailCallback() {},
  onChange: function onChange() {},
  onRemove: function onRemove() {},
  beforeUpload: function beforeUpload() {},
  onSuccess: function onSuccess() {},
  onSucess: undefined,
  onFail: function onFail() {},
  btnText: locale.lng('FileInput.choice'),
  btnProps: null,
  removeBtnText: locale.lng('FileInput.remove'),
  removeBtnProps: null
};
FileInput.propTypes = {
  action: PropTypes.string,
  autoUpload: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultFileName: PropTypes.string,
  uploadParams: PropTypes.object,
  name: PropTypes.string,
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  withCredentials: PropTypes.bool,
  dataFormat: PropTypes.string,
  validityFailCallback: PropTypes.func,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  beforeUpload: PropTypes.func,
  onSuccess: PropTypes.func,
  onSucess: PropTypes.func,
  onFail: PropTypes.func,
  placeholder: PropTypes.string,
  buttonOnly: PropTypes.bool,
  btnText: PropTypes.node,
  btnProps: PropTypes.object,
  removeBtnText: PropTypes.node,
  removeBtnProps: PropTypes.object
};
export default FileInput;